import { getBaseUrl, getQueryVariable } from '@/utils/http';

// 未登陆状态下保存参数
export const handleStuDetailJupmParams = () => {
  const path = getQueryVariable('path');
  const stu_id = getQueryVariable('stu_id');
  if (path === '/student-detail' && stu_id) {
    localStorage.setItem('path', path);
    localStorage.setItem('stu_id', stu_id);
  }
};

// 登陆后跳转
export const handleStuDetailJupm = () => {
  const path = localStorage.getItem('path');
  const stu_id = localStorage.getItem('stu_id');
  if (path === '/student-detail' && stu_id) {
    const prevPathName = window.location.pathname;
    if (prevPathName !== '/') {
      window.location.href = `${getBaseUrl('')}${prevPathName}#/student-detail?stu_id=${stu_id}`;
    } else {
      window.location.href = `${getBaseUrl('')}/#/student-detail?stu_id=${stu_id}`;
    }
    localStorage.removeItem('path');
    localStorage.removeItem('stu_id');
  }
};
